import React from 'react';
import Thead from "components/table/components/thead";
import TbodyAdmin from "components/table/components/tbodyAdmin";
import ScrollableTableWrapper from "components/table/components/ScrollableTableWrapper";

const TableAdmin = ({champsHeader, champsBody}) => {
    return (
        <>
                <ScrollableTableWrapper className="overflow-y-visible w-full">
                <table className="jbz-table table-auto w-full min-w-[1200px] text-gray-500 space-y-6 ft-sm">
                        <thead className="sticky top-0 z-10">
                        <Thead champsHeader={champsHeader} isWaiting={false}/>
                        </thead>
                        <tbody>
                    {
                        <TbodyAdmin champsBody={champsBody}/>
                    }
                        </tbody>
                    </table>
                </ScrollableTableWrapper>
        </>
    );
};

export default TableAdmin;